import { currentStage } from 'config'
import React, { useState, useEffect } from 'react'

export function LoadingPicture(props: {
  style: React.CSSProperties
  imageId: string
  size: 'medium' | 'fullsize'
  stage?: string
}) {
  const finalStage = props.stage || currentStage

  // State to determine whether the fullsize image has finished loading.
  const [fullLoaded, setFullLoaded] = useState(false)

  // Define URLs for thumbnail and fullsize images.
  const thumbnailUrl = `https://jasonandfriends-${finalStage}-pictures-bucket.s3.us-east-1.amazonaws.com/processed/${props.imageId}/thumbnail_${props.imageId}`
  const fullsizeUrl = `https://jasonandfriends-${finalStage}-pictures-bucket.s3.us-east-1.amazonaws.com/processed/${props.imageId}/${props.size}_${props.imageId}`

  useEffect(() => {
    const fullImage = new Image()
    fullImage.onload = () => {
      // Once the fullsize image is loaded, update the state.
      setFullLoaded(true)
    }
    fullImage.src = fullsizeUrl
  }, [fullsizeUrl])

  return (
    // Wrapping div to clip the blurred edges.
    <div
      style={{
        ...props.style,
        overflow: 'hidden',
        display: 'inline-block',
      }}
    >
      <img
        src={fullLoaded ? fullsizeUrl : thumbnailUrl}
        alt="Jason and Tammy"
        style={{
          width: '100%',
          height: 'auto',
          filter: fullLoaded ? 'blur(0px)' : 'blur(10px)',
          transition: 'filter 0.25s ease-in-out',
          display: 'block',
        }}
      />
    </div>
  )
}
